module.exports = new __parcel__URL__("bossfight_damage_button_inactive.8498b20c.png").toString();